module.exports = __webpack_public_path__ + "MarkerDefault.116b430672e79dc5d2cdfaca792ca8c8.png";